module.exports = __webpack_public_path__ + "static/media/mikmak-circle-logo-black.92f461ee.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/mikmak-circle-logo-black.png
// module id = 373
// module chunks = 0